export enum CreateContextualCommentButtonState {
  Enabled = 'Enabled',
  SenderHasMadeChanges = 'SenderHasMadeChanges',
  YouAreNotTheSender = 'YouAreNotTheSender',
  ContentUpdatePending = 'ContentUpdatePending',
  SomeoneIsEditing = 'SomeoneIsEditing',
}
